export const vhToPixel = (value = 0, withPixel = false) => {
  if (typeof window === 'undefined') return undefined;

  const number = (window.innerHeight * value) / 100;
  return withPixel ? `${number}px` : number;
};

export function vwToPixel(value = 0, withPixel = false) {
  if (typeof window === 'undefined') return undefined;

  const number = (window.innerWidth * value) / 100;
  return withPixel ? `${number}px` : number;
}

export function getWindowWidth() {
  return typeof window === 'undefined' ? undefined : window.innerWidth;
}

export function getWindowHeight() {
  return typeof window === 'undefined' ? undefined : window.innerHeight;
}

export function getScrollBarWidth() {
  const inner = document.createElement('p');
  inner.style.width = '100%';
  inner.style.height = '200px';

  const outer = document.createElement('div');
  outer.style.position = 'absolute';
  outer.style.top = '0px';
  outer.style.left = '0px';
  outer.style.visibility = 'hidden';
  outer.style.width = '200px';
  outer.style.height = '150px';
  outer.style.overflow = 'hidden';
  outer.appendChild(inner);

  document.body.appendChild(outer);
  const fullWidth = inner.offsetWidth;
  outer.style.overflow = 'scroll';
  let contentWidth = inner.offsetWidth;

  if (fullWidth === contentWidth) {
    contentWidth = outer.clientWidth;
  }

  document.body.removeChild(outer);

  return (fullWidth - contentWidth);
}
